import { AvForm } from "availity-reactstrap-validation";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import { useEffect, useState } from "react";
import BaseService from "../../../services/BaseService";
import { toast } from "react-toastify";
import BannerService from "../../../services/BannerService";

const Gallery = () => {
	const [formData, setFormData] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const [loader, setLoader] = useState(false);
	const bannerService = new BannerService();

	useEffect(() => {
		bannerService.find("gallery").then((res) => {
			if (res?.status === 200) {
				let response = res?.data?.data;
				if (!!response?.banner_images?.length) {
					setFormData(response?.banner_images?.map((img) => img?.url));
				}
			}
		});
	}, []);

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!!filesData?.length) {
			setLoader(true);
			Promise.all(
				filesData?.map((response) => new BaseService().postUpload(response))
			).then((response) => {
				setFormData((prev) => [
					...prev,
					...response?.map((img) => img?.data?.url),
				]);
				setLoader(false);
			});
		}
	};

	const submit = () => {
		if (!formData?.length) {
			toast.error("Upload Images");
			return;
		}
		let data = {
			images: formData,
			tag: "gallery",
		};
		setLoader(true);
		bannerService.create(data).then((response) => {
			if (response?.status === 201) {
				toast.success(response?.data?.message);
				setLoader(false);
			}
		});
	};

	return (
		<div>
			<AvForm className="form-horizontal mb-5" onValidSubmit={submit}>
				<Row>
					<Col md={12} className="text-black fs-24 fw-bold mb-3">
						{Translate[lang].gallery}
					</Col>
					<Col md={12}>
						<label className="text-label mb-0">{Translate[lang].images}</label>
						<div className="upload w-50 mb-4">
							<input
								type="file"
								name="image"
								id="image"
								accept="image/*"
								multiple
								onChange={(e) => fileHandler(e, "clients")}
							/>
							<p>{Translate[lang].upload_image}</p>
							{!formData?.length ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
						{!!formData?.length && (
							<div className="row">
								{formData?.map((res, index) => (
									<div className="col-md-2 col-3 mb-3">
										<div className="d-flex flex-column">
											<i
												className="las la-trash text-danger fs-20 cursor-pointer"
												onClick={() =>
													setFormData((prev) =>
														prev?.filter((_, ind) => index !== ind)
													)
												}
											/>
											<img
												src={res}
												alt={index}
												key={index}
												height={140}
												style={{ borderRadius: "8px" }}
												width={120}
											/>
										</div>
									</div>
								))}
							</div>
						)}
					</Col>
					<Col md={12} className="mt-3">
						<Button type="submit" disabled={loader} variant="primary">
							{Translate[lang].submit}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};
export default Gallery;
